<!--国家信息-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form layout="inline" :form="form">
          <a-form-item label="国家名称">
            <a-input v-decorator="['countryName']" placeholder="请输入国家名称"></a-input>
          </a-form-item>
        </a-form>
        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">国家列表</div>
      <div class="queryView-actions">
        <a-button class="app-btn" @click="addRow">
          <app-icon type="icon-tianjia"></app-icon>
          添加国家
        </a-button>
      </div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          :rowKey="useRowIndex"
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '8%',
        align: 'center',
        customRender: (text, row, index) => {
          return <div>{this.pageSize * (this.pageNumber - 1) + index + 1}</div>
        },
      },
      {
        title: '国家名',
        width: '12%',
        align: 'center',
        dataIndex: 'countryName',
      },
      {
        title: '是否热门',
        width: '10%',
        align: 'center',
        dataIndex: 'hot',
        customRender: text => {
          return <span>{text === 1 ? '是' : '否'}</span>
        },
      },
      {
        title: '排序',
        width: '8%',
        align: 'center',
        dataIndex: 'sort',
      },
      {
        title: '最后操作人',
        width: '12%',
        align: 'center',
        dataIndex: 'operator',
      },
      // 操作时间是否是这个字段
      {
        title: '最后操作时间',
        width: '15%',
        align: 'center',
        dataIndex: 'updateTime',
      },
      // 操作时间是否是这个字段
      {
        title: '状态',
        width: '15%',
        align: 'center',
        dataIndex: 'online',
        customRender: text => {
          return <span>{text ? '上线中' : '已下线'}</span>
        },
      },
      {
        title: '操作',
        width: '10%',
        align: 'center',
        dataIndex: 'detail',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-5 justify-center items-center text-primary-500">
              <span
                style="cursor:pointer"
                onClick={() => {
                  this.editRow(row)
                }}
              >
                查看
              </span>
              <span
                style="cursor:pointer"
                onClick={() => {
                  this.changeStatus(row)
                }}
              >
                {row.online ? '下线' : '上线'}
              </span>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      modal: {
        visible: false,
        title: '',
        data: {},
      },
      dataSource: [],
    }
  },
  components: {
    Page,
  },
  computed: {
    typesMap() {
      return {}
    },
  },
  mounted() {
    this.doQuery()
  },
  methods: {
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const { countryName } = this.form.getFieldsValue()
        const res = await this.$axios.get('/visa/admin/country', {
          params: {
            countryName,
            page: _pageNumber,
            limit: _pageSize,
          },
        })
        this.countTotal = Number(res.count)
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    editRow(row) {
      this.$routex.reloadNext()
      this.$router.push({
        path: '/m/scopeMain/stateInfo/addState',
        query: {
          countryId: row.countryId,
        },
      })
    },
    async changeStatus(row) {
      await this.$axios.put(`/visa/admin/country/status?countryId=${row.countryId}&online=${!row.online}`)
      this.$message.success('操作成功')
      this.doQuery()
    },
    addRow() {
      this.$routex.reloadNext()
      this.$router.push({
        path: '/m/scopeMain/stateInfo/addState',
      })
    },
  },
}
</script>

<style lang="less"></style>
